<template>
  <div class="param over-scroll">
    <component ref="local"
               :is="curTherapyKey"
               :isSetting="isSetting" />
  </div>
</template>

<script>
const importSettings = therapy => () => {
  return import(/* webpackChunkName: "therapy" */ `@therapy/scenes/${therapy}/settings.vue`)
}
import { mapState, mapMutations } from 'vuex'
export default {
  props: {
    isSetting: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      // curTherapyKey: 'AN',
    }
  },
  components: {
    // AN: () => import(`./AN`),
    AN: importSettings('AN'),
    SV: importSettings(`SV`),
    FU: importSettings(`FU`),
    STE: importSettings(`STE`),
    RoadRace: importSettings(`RoadRace`),
    AC: importSettings(`AC`),
    Saccadic: importSettings(`Saccadic`),
    Pursuits: importSettings(`Pursuits`),
    Groffman: importSettings(`Groffman`),
    VisualMemory: importSettings(`VisualMemory`),
    Fish: importSettings('Fish'),
    Plane: importSettings('Plane'),
    Tank: importSettings('Tank'),
    // AN: () => lazyLoadView(import(`@therapy/scenes/AN/settings.vue`)),
  },
  computed: {
    ...mapState({
      curTherapyKey: state => {
        // return state.therapy.curTherapy
        if (state.therapy && state.therapy.curTherapy.name) {
          return state.therapy.curTherapy.name
        }
      },
    }),
  },
  // watch: {
  //   curTherapy() {
  //     this.curTherapyKey = curTherapy.name
  //   },
  // },
  updated() {
    this.updateCurConfig()
  },
  methods: {
    ...mapMutations('therapy', [
      'setCurConfig',
      'clearCurConfig',
      'setGlobalConfig',
    ]),
    updateCurConfig() {
      // 如果游戏进行中 则更新训练
      let local = this.$refs.local
      if (local && local.setCurConfig && local.config) {
        console.log('更新本地设置')
        this.$refs.local.setCurConfig(local.config)
      }
      this.$store.dispatch('UpdateTherapy')
    },
  },
}
</script>

